module.exports = __webpack_public_path__ + "img/loop.3b6b7b4c.png";